module.exports = __webpack_public_path__ + "templates/modal-change-password-tpl.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/login/templates/modal-change-password-tpl.html
// module id = Ks0w
// module chunks = 1